import { defineRouting } from 'next-intl/routing'
import { createNavigation } from 'next-intl/navigation'

import { APP_LANGUAGES, DEFAULT_LANG } from '@/constants'

export const routing = defineRouting({
  locales: APP_LANGUAGES,
  localePrefix: 'as-needed',
  defaultLocale: DEFAULT_LANG,
})

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing)
